import React from 'react';

export const Optimized = () => {
  return (
    <section className="rapid-fire-optimized-section-parent">
      <div className="rapid-fire-optimized-section">
        <div className="rapid-fire-optimized-text">
          <h2 className="rapid-fire-optimized-title">
            <span className="rapid-optimized-title-line">Optimized for</span>
            <span className="rapid-optimized-title-line">Any Environment</span>
          </h2>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="100%"
            height="2"
            viewBox="0 0 100 2"
            preserveAspectRatio="none"
            className="rapid-fire-optimized-line"
          >
            <path d="M0 0.5H627" stroke="url(#paint0_linear_1053_2704)" />
            <defs>
              <linearGradient
                id="paint0_linear_1053_2704"
                x1="0"
                y1="1"
                x2="100"
                y2="1"
                gradientUnits="userSpaceOnUse"
              >
                <stop offset="0.509" stopColor="#FF2238" />
                <stop offset="1" stopColor="#FF2238" stopOpacity="0" />
              </linearGradient>
            </defs>
          </svg>
          <p className="rapid-fire-optimized-description">
            Whether you're racing indoors, flying through abandoned buildings,
            or exploring the great outdoors for long-range flights, rapidFIRE is
            built to perform. It offers high sensitivity and selectivity, even
            in areas with challenging multi-path interference, making it perfect
            for any flying scenario.
          </p>
        </div>
      </div>
    </section>
  );
};
